// extracted by mini-css-extract-plugin
module.exports = {"controlsWrapper":"carousel_controlsWrapper__j5qQs","pagination":"carousel_pagination__PMl8f","customPagination":"carousel_customPagination__wu4W_"};